'use client';

import { Breakpoint, freddyTheme, useMediaQuery } from '@coolblue-development/freddy';
import { Device } from '@coolblue-development/next-request-context';
import { useRequestContext } from '@coolblue-development/next-request-context/client';

export const useBreakpoints = (breakpoint: Exclude<Breakpoint, 'xs'> = 'md') => {
  const { device } = useRequestContext();
  const isMobile = useMediaQuery(
    freddyTheme.breakpoint.maxWidth(breakpoint),
    device === Device.MOBILE
  );
  const isDesktop = useMediaQuery(
    freddyTheme.breakpoint.minWidth(breakpoint),
    device === Device.DESKTOP
  );

  return {
    isMobile,
    isDesktop
  };
};
